/* Saber Legacy — meses sin intereses en la tienda (actualizado 18 oct 2026).
   Shopify Payments: 3 MSI desde $3,000 · 6 desde $3,500 · 9 desde $5,000 · 12 desde $7,000.
   Decisión de Juan (18 oct): en la tienda solo se anuncia "Hasta 12 MSI", sin montos
   mínimos ni mensualidades. El plazo exacto lo ve el cliente al pagar.
   - Ficha (saber-buybox): la caja escribe "12 meses sin intereses de $X"; aquí se cambia a
     "Hasta 12 meses sin intereses" (o "desde $3,000" si el precio no llega). Se vuelve a
     aplicar cada vez que el cliente cambia de opción.
   - Pie de página ("12 MSI DISPONIBLES") y renglón de confianza del carrito ("12 MSI"). */
(function () {
  var MINIMO = 300000; // centavos: abajo de $3,000 no hay meses
  var AVISO = 'Con tarjetas participantes · sin enganche';

  /* Solo escribe si cambia: escribir lo mismo dispararía otra vez al observador. */
  function poner(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function ficha() {
    var els = document.querySelectorAll('[data-sl-msi],[data-sl-msishort]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var largo = el.hasAttribute('data-sl-msi');
      var m = (el.textContent || '').match(/^12 (?:meses sin intereses|MSI) de \$([\d,]+(?:\.\d+)?)/);
      if (!m) continue;
      var precio = Math.round(parseFloat(m[1].replace(/,/g, '')) * 1200);
      var aviso = largo && el.parentNode ? el.parentNode.querySelector('span') : null;
      if (precio >= MINIMO) poner(el, largo ? 'Hasta 12 meses sin intereses' : 'Hasta 12 MSI');
      else poner(el, largo ? 'Meses sin intereses desde $3,000' : 'MSI desde $3,000');
      poner(aviso, AVISO);
    }
  }

  function fijos() {
    var pie = document.querySelectorAll('.slfooter__trust-grid span');
    for (var i = 0; i < pie.length; i++) {
      var nodos = pie[i].childNodes;
      for (var j = 0; j < nodos.length; j++) {
        var nd = nodos[j];
        if (nd.nodeType === 3 && nd.nodeValue.trim() === '12 MSI DISPONIBLES') nd.nodeValue = 'HASTA 12 MSI';
      }
    }
    var cart = document.querySelectorAll('.slcart-v2__trust b');
    for (var k = 0; k < cart.length; k++) {
      if ((cart[k].textContent || '').trim() === '12 MSI') {
        poner(cart[k], 'HASTA 12 MSI');
        poner(cart[k].nextElementSibling, 'Tarjetas participantes');
      }
    }
  }

  function todo() { ficha(); fijos(); }

  function iniciar() {
    todo();
    if (window.MutationObserver) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () { pendiente = false; todo(); }, 30);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
